import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, DatePickerView, MuiPickersUtilsProvider, TimePicker } from "@material-ui/pickers";
import { Controller } from "react-hook-form";
import { DateField, InputFieldProps } from "../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import OpsDateUtils from "../utils/OpsDateUtils";

interface DateFieldProps extends InputFieldProps<Date> {
  /**
   * Show clear action in picker dialog
   * @default
   * false
   */
  clearable?: boolean;
  /**
   * If `true`, includes time input
   */
  time?: boolean;
  /**
   * Min accepted date
   */
  minDate?: Date;
  /**
   * Max accepted date
   */
  maxDate?: Date;
  /**
   * Array of views to show
   * @type {Array<"year" | "date" | "month">}
   */
  views?: Array<DatePickerView>;
  /**
   * First view to show in DatePicker
   */
  openTo?: DatePickerView;

  utils?: any;
  /**
   * If `true`, shows time in UTC
   */
  toUTC?: boolean;
  /**
   * If `true`, shows time in UTC
   */
  format?: string;
  /**
   * If `true`, disable toolbar
   */
  disableToolbar?: boolean;

  onChange?: (value: any) => void;
}

export function DateFieldComponent(props: DateFieldProps) {
  return (
    <div>
      <Controller
        name={props.propertyName}
        control={props.control}
        rules={{ required: props.required }}
        defaultValue={props.required ? props.defaultValue || new Date() : null}
        render={({ field }) => (
          <MuiPickersUtilsProvider utils={props.utils ?? DateFnsUtils}>
            {props.toUTC ? (
              <DatePicker
                disableToolbar={props.disableToolbar}
                minDate={props.minDate}
                maxDate={props.maxDate}
                views={props.views}
                openTo={props.openTo}
                label={props.label}
                format={props.format || "MMMM do, yyyy"}
                {...field}
                inputVariant={props.variant ?? "filled"}
                error={!!props.errors[props.propertyName]}
                helperText={props.errors[props.propertyName] && props.label + " should be provided"}
                clearable={props.clearable}
                readOnly={props.readOnly}
                disabled={props.readOnly}
                value={OpsDateUtils.makeLocalAppearUTC(field.value)}
                onChange={(value) => {
                  field.onChange({ target: { value: OpsDateUtils.localToUTC(value) } });
                  props.onChange && props.onChange(value?.valueOf());
                }}
              />
            ) : (
              <DateField
                control={props.control}
                register={props.register}
                errors={props.errors}
                propertyName={props.propertyName}
                label={props.label}
                required={props.required}
                readOnly={props.readOnly}
              />
            )}
            {props.time && (
              <TimePicker
                label={props.label + " hour"}
                {...field}
                inputVariant={props.variant ?? "filled"}
                error={!!props.errors[props.propertyName]}
                helperText={props.errors[props.propertyName] && props.label + " should be provided"}
                clearable={props.clearable}
                readOnly={props.readOnly}
                disabled={props.readOnly}
              ></TimePicker>
            )}
          </MuiPickersUtilsProvider>
        )}
      />
    </div>
  );
}
